<template>
  <div id="playPauseControls" ref="playPauseControlsRef" style="display: none">
    <div>
      <img
        @click="handleBackwardSkip"
        class="skip-button"
        src="../assets/img/arrow-left.png"
        alt=""
      />
    </div>

    <div id="playButton" ref="playButton" v-if="store.videoControlBtn === 'play'">
      <img
        ref="playButtonImg"
        src="../assets/img/play.png"
        class="play-button"
        @mouseover="onHover('PLAY')"
        @mouseout="onMouseOut('PLAY')"
        @click="onPlayButtonClick"
      />
    </div>

    <div id="pauseButton" v-show="store.videoControlBtn === 'pause'" ref="pauseButton">
      <img
        ref="pauseButtonImg"
        src="../assets/img/pause.png"
        class="pause-button"
        @mouseover="onHover('PAUSE')"
        @mouseout="onMouseOut('PAUSE')"
        @click="onPauseButtonClick"
      />
    </div>

    <div>
      <img
        class="skip-button"
        @click="handleForwardSkip"
        src="../assets/img/arrow-right.png"
        alt=""
      />
    </div>
  </div>
</template>

<script setup>
import { useLensesStore } from '@/stores/Lenses'
import { ref, inject } from 'vue'

const store = useLensesStore()
const guardPlay = inject('guardPlay', null)
const playButton = ref(null)
const pauseButton = ref(null)
const playButtonImg = ref(null)
const pauseButtonImg = ref(null)

function onHover(target) {
  const buttonImg = target === 'PLAY' ? playButtonImg.value : pauseButtonImg.value
  buttonImg.style.transform = 'scale(1.25)'
  buttonImg.style.transition = 'transform 0.5s ease-in-out'
}

function onMouseOut(target) {
  const buttonImg = target === 'PLAY' ? playButtonImg.value : pauseButtonImg.value
  buttonImg.style.transform = 'scale(1)'
  buttonImg.style.transition = 'transform 0.5s ease-in-out'
}

function onPlayButtonClick() {
  if (guardPlay?.()) return
  store.playBothVideos()
}

function onPauseButtonClick() {
  store.pauseBothVideos()
}

const handleForwardSkip = () => {
  store.skipBothVideos('forward')
}

const handleBackwardSkip = () => {
  store.skipBothVideos('backward')
}
</script>

<style scoped></style>
